import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import firebase from 'firebase/compat/app'; // Update import statement
import { getStorage } from 'firebase/storage';
import 'firebase/compat/firestore'; // Update import statement

const firebaseConfig = {
    apiKey: "AIzaSyC1BPS8JfikKL2uIu1vwVXWYBpAFI-FRI0",
    authDomain: "bridge-127.firebaseapp.com",
    projectId: "bridge-127",
    storageBucket: "bridge-127.firebasestorage.app",
    messagingSenderId: "506971992424",
    appId: "1:506971992424:web:b5cb4e4590eadb2226e6dd"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app)

const storage = getStorage(app);


firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();


export { app, auth, db, storage };
